import { render } from "./RemarkModal.vue?vue&type=template&id=38a5d1b0&scoped=true"
import script from "./RemarkModal.vue?vue&type=script&lang=js"
export * from "./RemarkModal.vue?vue&type=script&lang=js"

import "./RemarkModal.vue?vue&type=style&index=0&id=38a5d1b0&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38a5d1b0"]])

export default __exports__